import { render, staticRenderFns } from "./LanguageOverrides.vue?vue&type=template&id=79b245b2"
import script from "./LanguageOverrides.vue?vue&type=script&lang=js"
export * from "./LanguageOverrides.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports